import React from "react";
import clsx from "clsx";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import { Theme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import IconButton from "@material-ui/core/IconButton";
import RefreshIcon from "@material-ui/icons/Refresh";
import Typography from "@material-ui/core/Typography";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import Breakpoints from "common/breakpoints";
import useStyles from "./styles";

interface Props {
  horse: racehorse360.IHorse;
  onClose: () => void;
  onResetClick: () => void;
  isResetAvailable: boolean;
}

const OverlayHeader = (props: Props) => {
  const { horse, onClose, onResetClick, isResetAvailable } = props;
  const classes = useStyles();

  const matchesDownSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(Breakpoints.SM_600)
  );

  const handleCloseClick = () => {
    onClose();
  };

  const handleResetClick = () => {
    onResetClick();
  };

  return (
    <Grid container className={classes.topBar} justifyContent="space-between">
      <Grid item className={clsx(classes.topBarItem, classes.leftItem)}>
        <IconButton
          color="primary"
          onClick={handleResetClick}
          disabled={!isResetAvailable}
          classes={{
            root: classes.resetButton,
            label: classes.resetButtonLabel
          }}
        >
          <RefreshIcon className={classes.icon} />
          {!matchesDownSm && (
            <Typography className={classes.resetButtonTitle}>
              RESET CONDITIONS
            </Typography>
          )}
        </IconButton>
      </Grid>
      <Grid item className={clsx(classes.topBarItem, classes.centerItem)}>
        <Typography className={classes.title}>Preferred Conditions</Typography>
        <Typography className={classes.name}>{horse.name}</Typography>
      </Grid>
      <Grid item className={clsx(classes.topBarItem, classes.rightItem)}>
        <IconButton color="primary" onClick={handleCloseClick}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default OverlayHeader;
